import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { DataService } from '../data/data.service';
import { SupportEmail } from '../data/support-email';

@Component({
  selector: 'app-email-support-modal',
  templateUrl: './email-support-modal.component.html',
  styleUrls: ['./email-support-modal.component.css']
})
export class EmailSupportModalComponent extends ModalBaseComponent<SupportEmail> implements OnInit {

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  userInput: string = "";
  supportEmail: string = "support@joyschoolenglish.com";

  userName: string;
  userEmail: string;

  initializeNewData(): void {
    this.data.body = "";
    this.data.subject = `Support request from ${this.userName}`;
    this.submitButtonText = "Send";
  }
  isInputValid(): boolean {
    return !!this.userInput;
  }
  saveEdit(): void {
    throw new Error('Editing sent emails not possible.');
  }
  saveNew(): void {
    this.isWaiting = true;
    this.data.body = `Support request from ${this.userName} at ${this.userEmail}: <br> ${this.userInput}`;
    this.dataService.sendSupportEmail(this.data).subscribe(o => this.saveComplete(undefined));
  }

  ngOnInit() {
    this.data = {
      subject: "",
      body: ""
    };
    this.modalHeader = "Contact Support";
    this.userInput = "";

    let session = JSON.parse(localStorage['session']);
    this.userName = session.Name;
    this.userEmail = session.Email;
  }

}
